import styled from 'styled-components';

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  height: 100%;

  color: ${({ theme }) => theme.palette.text.primary};
`;
